<template>
  <div class="vc-home-header pt-2 pb-2">
    <div>
      <v-btn
        class="vc-home-file-button"
        color="primary"
        depressed
        @click="selectDate"
      >
        <v-icon class="vc-home-file-button-icon">
          mdi-file
        </v-icon>
      </v-btn>
    </div>
    <div v-if="currentPlace" class="vc-home-header-dropdown">
      <v-btn
        style="display: inline-block; justify-content: center; align-items: center;"
        height="20px"
        depressed
        color="primary"
      >
        <div class="vc-home-header-button-text">
          {{ selectedPlace ? `${selectedPlace.name}` : `${currentPlace.name}` }}
        </div>
        <v-icon right dark>
          mdi-chevron-down
        </v-icon>
      </v-btn>

      <div class="dropdown-content pa-2">
        <v-btn
          v-for="(place, i) in places"
          :key="`${place.name}${i}`"
          text
          color="primary"
          @click="selectPlace(place)"
        >
          <div>
            {{ `${place.name}` }}
          </div>
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="openSelectDialog" persistent max-width="400">
      <v-card class="primaryLight">
        <div class="vc-w-100 vc-flex-center mt-1">
          <v-icon size="85px" color="primaryDark">
            mdi-alert-circle-outline
          </v-icon>
        </div>
        <v-card-title
          class="headline vc-text-primaryDark pt-2 pb-2 text-center"
        >
          Deseja mesmo trocar de local?
        </v-card-title>
        <v-card-text class="vc-text-bold pb-3"
          >Ao confirmar a ação você irá trocar de
          {{ `${currentPlace.name}` }} para
          {{ `${placeStore.name}` }}</v-card-text
        >
        <v-card-text class="pb-0">
          <v-alert border="left" color="primary" type="info">
            Ao confirmar a ação, o histórico de ultima ficha será perdido.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeDialog">
            <div class="vc-text-button">fechar</div>
          </v-btn>
          <v-btn color="primary" @click="setTokensByPlace">
            <div class="vc-text-button">confirmar</div>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="openSelectDateDialog" persistent max-width="500">
      <v-card class="primaryLight text-center">
        <div class="vc-w-100 vc-flex-center mt-1">
          <v-icon size="85px" color="primaryDark">
            mdi-note-search-outline
          </v-icon>
        </div>
        <v-card-title
          class="headline vc-text-primaryDark pt-2 pb-2 text-center justify-center"
        >
          Relatório de fichas
        </v-card-title>
        <v-card-text class="vc-text-bold pb-3">
          Selecione o intervalo para emissão do relatório
        </v-card-text>

        <v-card-text>
          <v-menu
            v-model="showStartDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="startDate"
                label="Início"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="pt-br"
              v-model="startDate"
              color="primaryDark"
              @input="showStartDatePicker = false"
            ></v-date-picker>
          </v-menu>

          <v-menu
            v-model="showEndDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="endDate"
                label="Fim"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="pt-br"
              v-model="endDate"
              color="primaryDark"
              @input="showEndDatePicker = false"
            ></v-date-picker>
          </v-menu>
        </v-card-text>

        <v-card-text v-if="!startDate && !endDate">
          <v-alert border="left" type="warning">
            <small class="warning-text">
              <strong>Escolha ao menos uma data.</strong></small
            >
          </v-alert>
        </v-card-text>

        <v-card-text class="pb-0">
          <v-alert border="left" color="success" type="info">
            Será aberta uma janela com todas as fichas para data selecionada.
          </v-alert>
          <v-alert v-if="showAlert" border="left" color="#800000" type="error">
            {{ alertMessage }}
          </v-alert>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="error" @click="closeDialog">
            <div class="vc-text-button">fechar</div>
          </v-btn>
          <v-btn
            :disabled="!startDate && !endDate"
            color="primary"
            @click="confirmDateSelection"
          >
            <div class="vc-text-button">confirmar</div>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { VDatePicker } from "vuetify/lib";
import "vuetify/src/locale/pt.ts";

export default {
  name: "vc-home-header",
  components: {
    VDatePicker,
  },
  data() {
    return {
      selectedPlace: "",
      placeStore: "",
      openSelectDialog: false,
      openSelectDateDialog: false,
      showStartDatePicker: false,
      showEndDatePicker: false,
      startDate: "",
      endDate: "",
      showAlert: false,
      alertMessage: "",
    };
  },
  props: {
    places: { type: Array, default: () => {} },
    currentPlace: { type: Object, default: () => {} },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.currentPlace) {
        this.selectedPlace = this.currentPlace;
      }
    },
    setTokensByPlace() {
      this.selectedPlace = this.placeStore;
      this.$store.dispatch("setTokensByPlace", this.selectedPlace).then(() => {
        this.closeDialog();
      });
    },
    selectPlace(place) {
      if (place._id != this.currentPlace._id) {
        this.openSelectDialog = true;
        this.placeStore = place;
      }
    },
    selectDate() {
      this.openSelectDateDialog = true;
    },
    closeDialog() {
      this.openSelectDialog = false;
      this.openSelectDateDialog = false;
      this.showStartDatePicker = false;
      this.showEndDatePicker = false;
      this.placeStore = "";
    },
    confirmDateSelection() {
      if (this.endDate === "" && this.startDate.value !== "") {
        this.endDate = this.startDate;
      }

      if (this.startDate === "" && this.endDate.value !== "") {
        this.startDate = this.endDate;
      }

      if (this.endDate < this.startDate) {
        this.startDate = this.endDate;
        this.showAlert = true;
        this.alertMessage = "Data de encerramento menor que a de começo. ";
        return;
      }
      this.closeDialog();

      let date = {
        start: this.startDate,
        end: this.endDate,
      };

      this.$store.dispatch("reports", date).then(() => {
        const allReports = this.$store.getters.allReports;
        this.$router.push({
          name: "History",
          params: {
            reports: allReports,
            startDate: this.startDate,
            endDate: this.endDate,
          },
        });
      });
    },
  },
};
</script>

<style scoped>
.vc-flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.text-center {
  text-align: center;
}

.justify-center {
  display: flex;
  justify-content: center;
}

.v-application .warning {
  border: solid 1px;
  border-color: #ffa500 !important;
  background-color: #ffa6006e !important;
  color: #ffa500;
}
.warning-text {
  color: #fff !important;
}
</style>
